import moment from "moment";

// eslint-disable-next-line
const weekMap: any = {
    0: '周日',
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六'
}

class Moment{
    getCurrentDate() {
        const currentTime = moment()
        return {
            hour: currentTime.format('HH:mm:ss'),
            day: currentTime.format('YYYY-MM-DD'),
            week: weekMap[currentTime.day()]
        }
    }
}

export default new Moment()